import {
  message
} from "antd";
import Cookies from "js-cookie";
import api_domain_config from "./config";
import store from "@/redux/store";

const request = (url, options) => {
  let controller = new AbortController(); //可用于中止fetch请求
  let HTTPUrl = url;
  let HTTPOptions = {
    method: "GET",
    signal: controller.signal
  };
  // Consolidation request
  Object.assign(HTTPOptions, options);

  //GET Method: query characters are attached to url behind;
  // if ((HTTPOptions.method === "GET" && options.data) || HTTPOptions.method === "HEAD") {
  //   let searchStr = "";
  //   if (options.data instanceof Object) {
  //     for (let i in options.data) {
  //       searchStr += i + "=" + options.data[i];
  //     }
  //   }
  //   HTTPUrl = url + "?" + searchStr;
  // }

  const status = {
    401535: '手机号当天获取验证码次数已超过上限', //总数超限
    401526: '请求频繁，请稍后再试！', //频次过快
    401400: '该邮箱已绑定其他账号',
  };

  return new Promise((resolve, reject) => {
    fetch(HTTPUrl, HTTPOptions)
      .then(res => {
        return res.json();
      })
      .then(response => {
        if (response && response.code) {
          if (response.code === 403) {
            message.warn('请重新登录账号');
            Cookies.remove("authorization", {
              domain: api_domain_config.DOMAIN
            });
            store.dispatch({
              type: "AUTHORIZATION",
              authorization: null,
            });
            //跳转测试登录购买页，上线后跳转首页
            setTimeout(() => {
              window.location.replace('https://www.niuxuezhang.cn/');
              // window.location.replace('http://127.0.0.1:56590/niuxuezhang-page/account-center/purchase/buy-test.html')
            }, 1000)
          } else if (response.code === 500) {
            message.error('服务器错误');
          } else if (status[response.code]) {
            message.warn(status[response.code]);
          } else if (response.code !== 200 && response.code !== 401404 && response.code !== 401412) {
            message.warn(response.msg || '系统错误');
          }
          resolve(response);
        }
        resolve(response);
      })
      .catch(error => {
        message.error(error)
        reject(error);
      });
  });
};

export default request;